const isDevelopment = process.env.NODE_ENV === 'development'

class ErrorLogger {
  constructor() {
    this.errors = []
    this.warnings = []
    this.maxLogs = 100
  }

  logError(err, vm, info) {
    const errorEntry = {
      timestamp: new Date().toISOString(),
      error: {
        message: err?.message || String(err),
        stack: err?.stack,
        info
      },
      component: vm?.$options?.name || vm?.$options?.__name || 'Unknown',
      route: window.location.pathname
    }

    this.errors.push(errorEntry)
    if (this.errors.length > this.maxLogs) {
      this.errors.shift()
    }

    if (isDevelopment) {
      console.group(`❌ Vue Error in ${errorEntry.component}`)
      console.error('Message:', errorEntry.error.message)
      console.error('Info:', info)
      console.error('Stack:', errorEntry.error.stack)
      console.error('Route:', errorEntry.route)
      console.groupEnd()
    }

    return errorEntry
  }

  logWarning(msg, vm, trace) {
    const warningEntry = {
      timestamp: new Date().toISOString(),
      warning: {
        message: msg,
        trace
      },
      component: vm?.$options?.name || vm?.$options?.__name || 'Unknown',
      route: window.location.pathname
    }

    this.warnings.push(warningEntry)
    if (this.warnings.length > this.maxLogs) {
      this.warnings.shift()
    }

    if (isDevelopment) {
      const isUndefinedProp = msg.includes('was accessed during render but is not defined')
      const isMissingDirective = msg.includes('Failed to resolve directive')
      
      if (isUndefinedProp || isMissingDirective) {
        console.group(`⚠️ Vue Warning in ${warningEntry.component}`)
        console.warn('Message:', msg)
        console.warn('Route:', warningEntry.route)
        if (trace) console.warn('Trace:', trace)
        console.groupEnd()
      }
    }

    return warningEntry
  }

  getRecentErrors(count = 10) {
    return this.errors.slice(-count)
  }

  getRecentWarnings(count = 10) {
    return this.warnings.slice(-count)
  }

  clearLogs() {
    this.errors = []
    this.warnings = []
  }

  exportLogs() {
    return {
      errors: this.errors,
      warnings: this.warnings,
      timestamp: new Date().toISOString()
    }
  }
}

export const errorLogger = new ErrorLogger()

export function setupErrorHandlers(app) {
  app.config.errorHandler = (err, vm, info) => {
    errorLogger.logError(err, vm, info)
  }

  app.config.warnHandler = (msg, vm, trace) => {
    errorLogger.logWarning(msg, vm, trace)
  }

  if (isDevelopment) {
    window.getErrorLogs = () => errorLogger.exportLogs()
    console.log('📊 Error logging enabled. Use window.getErrorLogs() to export logs.')
  }
}
